import { Component, ErrorInfo, ReactNode } from 'react';
import styled from 'styled-components';

interface ErrorBoundaryProps {
  children: ReactNode;
  label?: string;
}

interface ErrorBoundaryState {
  error: Error | null;
  info: string;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { error: null, info: '' };
  }

  static getDerivedStateFromError(error: Error): Partial<ErrorBoundaryState> {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.log('ErrorBoundary', this.props.label, error, errorInfo);
    this.setState({ info: errorInfo.componentStack || '' });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    const { error, info } = this.state;
    if (error === null) {
      return this.props.children;
    }
    return (
      <Wrap>
        <Title>화면을 표시하지 못했습니다</Title>
        <Message>{error.message || String(error)}</Message>
        <Detail>{(error.stack || '') + (info ? '\n\n' + info : '')}</Detail>
        <ReloadButton onClick={this.handleReload}>새로고침</ReloadButton>
      </Wrap>
    );
  }
}

const Wrap = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 16px;
  background: #12191f;
  color: #e8eef4;
  font-size: 13px;
  line-height: 1.5;
  box-sizing: border-box;
`;
const Title = styled.div`
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 8px;
`;
const Message = styled.div`
  color: #ff9c9c;
  word-break: break-all;
  margin-bottom: 12px;
`;
const Detail = styled.pre`
  white-space: pre-wrap;
  word-break: break-all;
  font-size: 11px;
  color: #8fa3b5;
  background: #0e141a;
  border: 1px solid #263340;
  border-radius: 8px;
  padding: 10px;
  margin: 0 0 12px;
`;
const ReloadButton = styled.button`
  appearance: none;
  border: 1px solid #38506a;
  background: #22384f;
  color: #e8eef4;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 14px;
`;

export default ErrorBoundary;
